import React, { useEffect, useState } from "react";
import profileImage from "../../../images/avatar/1.jpg"; // Placeholder path
import {
  getAllUserProfileList,
  getmedicalhistory,
  updatemedicalhistory,
  addInjuryhistory,
} from "../../../services/userApiService/userService";
import { Button, Modal, Form } from "react-bootstrap";
import { X, Plus } from "lucide-react";
import swal from "sweetalert";

// const notify = (type, message) =>
//   swal(type === "error" ? "Error" : "Success", message, type);
// import { getAllUserProfileList } from "../../../services/userApiService/userService";
import { Accordion } from "react-bootstrap";
import { ChevronDown } from "lucide-react";
import ProfileSidebar from "./ProfileSections/ProfileSidebar";
import BasicDetails from "./ProfileSections/BasicDetails";
import AcademyDetails from "./ProfileSections/AcademyDetails";
import MedicalHistory from "./ProfileSections/MedicalHistory";
import DigitalCertificates from "./ProfileSections/DigitalCertificates";
import AssessmentSystem from "./ProfileSections/AssessmentSystem";
import DocumentManagement from "./ProfileSections/DocumentManagement";
import TalentScouting from "./ProfileSections/TalentScouting";
import HostelManagement from "./ProfileSections/HostelManagement";
import TicketingSystem from "./ProfileSections/TicketingSystem";

const notify = (type, message) =>
  swal(type === "error" ? "Error" : "Success", message, type);

const ProfileComp = ({ user_category_main_id, user_id }) => {
  const [userData, setUserData] = useState({});
  const [medicalData, setMedicalData] = useState(null);
  const [userProfileImage, setUserProfileImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [medicalHistory, setMedicalHistory] = useState({});
  const [showMedicalModal, setShowMedicalModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [injuryList, setInjuryList] = useState([]);
  const [showInjuryModal, setShowInjuryModal] = useState(false);
  const [currentInjury, setCurrentInjury] = useState({
    name: "",
    date: "",
    documents: [],
  });
  const [documentInputs, setDocumentInputs] = useState([{ id: 1, file: null }]);

  const id =
    typeof localStorage !== "undefined" ? localStorage.getItem("id") : "1";
  const userCategoryMain =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("user_category_main")
      : "1";
  const token =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("access_token_admin")
      : null;

  const fetchUserData = async () => {
    setIsLoading(true);
    try {
      const response = await getAllUserProfileList(userCategoryMain, id);
      const data = response?.data?.data || {};
      setUserData(data);

      if (data?.user_category_main === 1) {
        const documents = data?.indivisual_docs || [];
        const getDocumentPath = (type) => {
          const doc = documents.find((d) => d.doc_name === type);
          return doc ? doc.doc_file : "";
        };
        const profileImg = getDocumentPath("profile_image");
        if (profileImg) {
          setUserProfileImage(profileImg.replace(/\\\//g, "/"));
        }
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchMedicalData = async () => {
    try {
      const response = await getmedicalhistory();
      console.log("Full Medical API Response:", response);
      console.log("Medical Data:", response?.data);
      
      const data = response?.data?.data;
      console.log("Extracted Data:", data);
      
      if (data) {
        setMedicalData(data);
        setMedicalHistory({
          height: data.height || "",
          weight: data.weight || "",
          blood_group: userData?.indivisual?.blood_group || "",
          age: userData?.indivisual?.age || "",
        });

        // Try multiple possible paths for injury history
        let injuries = [];
        if (Array.isArray(data.injury_history)) {
          injuries = data.injury_history;
        } else if (
          data.injury_history &&
          typeof data.injury_history === "object"
        ) {
          // If it's an object, try to convert to array
          injuries = Object.values(data.injury_history);
        } else if (Array.isArray(data.injuries)) {
          injuries = data.injuries;
        }

        // console.log("Processed Injury List:", injuries);
        setInjuryList(injuries);
      } else {
        console.log("No data found in response");
        setInjuryList([]);
      }
    } catch (error) {
      console.error("Error fetching medical data:", error);
      setInjuryList([]);
    }
  };

  useEffect(() => {
    if (userCategoryMain && id) {
      fetchUserData();
    }
  }, [userCategoryMain, id]);

  useEffect(() => {
    if (userData?.indivisual) {
      fetchMedicalData();
    }
  }, [userData]);

  const getProfileImageSrc = () => {
    if (userProfileImage) return userProfileImage;
    const docFile = (userData?.indivisual || userData?.organization)?.[9]
      ?.doc_file;
    return docFile || profileImage;
  };

  // Medical History Modal Handlers
  const handleEditMedical = () => {
    if (medicalData) {
      setMedicalHistory({
        height: medicalData?.height || "",
        weight: medicalData?.weight || "",
        blood_group: medicalData?.blood_group || "",
        age: medicalData?.age || "",
      });
    }
    setShowMedicalModal(true);
  };

  const handleMedicalChange = (e) => {
    setMedicalHistory({
      ...medicalHistory,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveMedical = async () => {
    if (!medicalHistory.height || !medicalHistory.weight) {
      notify("error", "Please fill all required fields");
      return;
    }

    try {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append("height", medicalHistory.height);
      formData.append("weight", medicalHistory.weight);
      formData.append("blood_group", medicalHistory.blood_group);
      formData.append("age", medicalHistory.age);

      const result = await updatemedicalhistory(formData);
      if (result.status) {
        notify("success", "Medical history updated successfully");
        setShowMedicalModal(false);
        await fetchMedicalData();
      } else {
        notify("error", result.message || "Failed to update medical history");
      }
    } catch (err) {
      console.error("Error updating medical history:", err);
      notify("error", "Failed to update medical history");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Injury History Modal Handlers
  const handleAddInjury = () => {
    setCurrentInjury({
      name: "",
      date: "",
      documents: [],
      existingDocs: [],
    });
    setDocumentInputs([{ id: 1, file: null }]);
    setShowInjuryModal(true);
  };

  const handleInjuryChange = (e) => {
    setCurrentInjury({
      ...currentInjury,
      [e.target.name]: e.target.value,
    });
  };

  const handleDocumentChange = (id, file) => {
    setDocumentInputs((prev) =>
      prev.map((input) => (input.id === id ? { ...input, file } : input)),
    );
  };

  const addDocumentInput = () => {
    if (documentInputs.length < 5) {
      setDocumentInputs([
        ...documentInputs,
        { id: documentInputs.length + 1, file: null },
      ]);
    }
  };

  const removeDocumentInput = (id) => {
    if (documentInputs.length > 1) {
      setDocumentInputs(documentInputs.filter((input) => input.id !== id));
    }
  };

  const handleSaveInjury = async () => {
    if (!currentInjury.name || !currentInjury.date) {
      notify("error", "Please fill injury name and date");
      return;
    }

    try {
      setIsSubmitting(true);
      const formData = new FormData();

      // Add new injury
      const newIndex = injuryList.length;
      formData.append(`injury_history[${newIndex}][name]`, currentInjury.name);
      formData.append(`injury_history[${newIndex}][date]`, currentInjury.date);

      // Add documents for new injury
      let docIndex = 0;
      documentInputs.forEach((input) => {
        if (input.file) {
          formData.append(
            `injury_history[${newIndex}][documents][${docIndex}]`,
            input.file,
          );
          docIndex++;
        }
      });

      const result = await addInjuryhistory(formData);

      if (result?.data?.status || result?.status) {
        notify("success", "Injury history added successfully");
        setShowInjuryModal(false);
        await fetchMedicalData();
      } else {
        notify(
          "error",
          result?.data?.message ||
            result?.message ||
            "Failed to add injury history",
        );
      }
    } catch (err) {
      console.error("Error adding injury history:", err);
      notify("error", "Failed to add injury history");
    } finally {
      setIsSubmitting(false);
    }
  };

  // console.log("Current Injury List State:", injuryList);
  // console.log("Medical Data State:", medicalData);

  return (
    <div className="container-fluid p-0">
      <div className="row g-4">
        {/* LEFT COLUMN: Sidebar */}
        <div className="col-xl-3 col-lg-4">
          <ProfileSidebar userData={userData} profileImage={userProfileImage} />
        </div>

        {/* RIGHT COLUMN: Content */}
        <div className="col-xl-9 col-lg-8">
          {/* 1. Basic Info Block */}
          <BasicDetails userData={userData} />

          {/* 2. Accordion Sections */}
          {/* alwaysOpen prop ensures multiple items can be open. */}
          <Accordion
            defaultActiveKey={["0"]}
            alwaysOpen
            className="profile-accordion custom-accordion"
          >
            {/* <Accordion.Item eventKey="0" className="mb-3 border-0 rounded overflow-hidden bg-white">
                  <Accordion.Header className="bg-white">
                     <span className="fw-medium fs-4 text-black">Academy/Association Details</span>
                     <ChevronDown size={20} className="custom-chevron text-black" />
                  </Accordion.Header>
                  <Accordion.Body className="bg-white">
                     <AcademyDetails userData={userData} />
                  </Accordion.Body>
                </Accordion.Item> */}
        
                {userCategoryMain !== "2" && (
                  <Accordion.Item eventKey="1" className="mb-3 border-0 rounded overflow-hidden bg-white">
                      <Accordion.Header className="bg-white">
                       <span className="fw-medium fs-4 text-black">Medical History</span>
                       <ChevronDown size={20} className="custom-chevron text-black" />
                    </Accordion.Header>
                    <Accordion.Body className="bg-white">
                       <MedicalHistory userData={userData} token={token} />
                    </Accordion.Body>
                  </Accordion.Item>
                )}
        
                <Accordion.Item eventKey="2" className="mb-3 border-0 rounded overflow-hidden bg-white">
                   <Accordion.Header className="bg-white">
                     <span className="fw-medium fs-4 text-black">Digital Certificates & Accreditation</span>
                     <ChevronDown size={20} className="custom-chevron text-black" />
                  </Accordion.Header>
                  <Accordion.Body className="bg-white">
                     <DigitalCertificates userData={userData} />
                  </Accordion.Body>
                </Accordion.Item>

            {userCategoryMain !== "2" && (
              <Accordion.Item
                eventKey="6"
                className="mb-3 border-0 rounded overflow-hidden bg-white"
              >
                <Accordion.Header className="bg-white">
                  <span className="fw-medium fs-4 text-black">
                    Hostel & Accommodation Management
                  </span>
                  <ChevronDown
                    size={20}
                    className="custom-chevron text-black"
                  />
                </Accordion.Header>
                <Accordion.Body className="bg-white">
                  <HostelManagement userId={id} />
                </Accordion.Body>
              </Accordion.Item>
            )}

            {/* <Accordion.Item eventKey="3" className="mb-3 border-0 rounded overflow-hidden bg-white">
                   <Accordion.Header className="bg-white">
                     <span className="fw-medium fs-4 text-black">Assessment & Evaluation System</span>
                     <ChevronDown size={20} className="custom-chevron text-black" />
                  </Accordion.Header>
                  <Accordion.Body className="bg-white">
                     <AssessmentSystem />
                  </Accordion.Body>
                </Accordion.Item>
                
                 <Accordion.Item eventKey="4" className="mb-3 border-0 rounded overflow-hidden bg-white">
                   <Accordion.Header className="bg-white">
                     <span className="fw-medium fs-4 text-black">Document Management & Verification</span>
                     <ChevronDown size={20} className="custom-chevron text-black" />
                  </Accordion.Header>
                  <Accordion.Body className="bg-white">
                     <DocumentManagement userData={userData} />
                  </Accordion.Body>
                </Accordion.Item>
                
                 <Accordion.Item eventKey="5" className="mb-3 border-0 rounded overflow-hidden bg-white">
                   <Accordion.Header className="bg-white">
                     <span className="fw-medium fs-4 text-black">Talent Scouting</span>
                     <ChevronDown size={20} className="custom-chevron text-black" />
                  </Accordion.Header>
                  <Accordion.Body className="bg-white">
                     <TalentScouting />
                  </Accordion.Body>
                </Accordion.Item>

                 <Accordion.Item eventKey="6" className="mb-3 border-0 rounded overflow-hidden bg-white">
                   <Accordion.Header className="bg-white">
                     <span className="fw-medium fs-4 text-black">Hostel & Accommodation Management</span>
                     <ChevronDown size={20} className="custom-chevron text-black" />
                  </Accordion.Header>
                  <Accordion.Body className="bg-white">
                     <HostelManagement />
                  </Accordion.Body>
                </Accordion.Item>
                
                 <Accordion.Item eventKey="7" className="mb-3 border-0 rounded overflow-hidden bg-white">
                   <Accordion.Header className="bg-white">
                     <span className="fw-medium fs-4 text-black">Ticketing System</span>
                     <ChevronDown size={20} className="custom-chevron text-black" />
                  </Accordion.Header>
                  <Accordion.Body className="bg-white">
                     <TicketingSystem />
                  </Accordion.Body>
                </Accordion.Item> */}
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default ProfileComp;
